export default {
  title: window.location.hostname.match(/(neositek)/) ? "Neositek Operadora" : "KBO Operadora",

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: "production",

  serviceStatus: {
    1: "Iniciado",
    2: "Buscando",
    3: "Subasta",
    4: "Pendiente",
    21: "No aceptado",
    6: "En curso",
    7: "Finalizado",
    8: "Devuelto",
    9: "Ausencia del cliente",
    10: "Cancelado por la operadora",
    11: "Cancelado tiempo",
    12: "Auto fin",
    22: "En cola",
  },

  taxiStatus: {
    1: "Apagado",
    2: "Desconectado",
    3: "Libre",
    4: "Ocupado",
  },

  tripStatus: {
    1: "STARTING",
    2: "SEARCHING",
    3: "AUCTION",
    4: "PENDING",
    6: "ON_TAXI",
    7: "FINISH",
    8: "GIVE_BACK",
    9: "NO_CLIENT",
    10: "OP_CANCEL",
    11: "TIME_CANCEL",
    12: "AUTO_FINISH",
    21: "NOT_ACEPTED",
    22: "QUEUED",
  },
  tripStatusToUser: {
    8: "Devuelto",
    9: "Ausencia",
    10: "Cancelado",
    11: "Cancelado Tiempo",
  },
};
